import { Injectable } from "@angular/core";
import { ActiveToast, IndividualConfig, ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private toastr: ToastrService) {}

  /**
   * Shows a success toast message.
   * @param message The message to display (default: 'Success').
   * @param title The title of the toast (optional).
   * @param options Additional toast configuration options.
   * @returns The ActiveToast instance for further interaction.
   */
  success(
    message: string = "Success",
    title?: string,
    options?: Partial<IndividualConfig>
  ): ActiveToast<any> {
    return this.toastr.success(message, title, options);
  }

  /**
   * Shows a success toast message (alias for success).
   * @param message The message to display (default: 'Show').
   * @param title The title of the toast (optional).
   * @param options Additional toast configuration options.
   * @returns The ActiveToast instance for further interaction.
   */
  show(
    message: string = "Show",
    title?: string,
    options?: Partial<IndividualConfig>
  ): ActiveToast<any> {
    return this.toastr.success(message, title, options);
  }

  /**
   * Shows an error toast message.
   * @param message The message to display (default: 'Error').
   * @param title The title of the toast (optional).
   * @param options Additional toast configuration options.
   * @returns The ActiveToast instance for further interaction.
   */
  error(
    message: string = "Error",
    title?: string,
    options?: Partial<IndividualConfig>
  ): ActiveToast<any> {
    return this.toastr.error(message, title, options);
  }

  /**
   * Shows an info toast message.
   * @param message The message to display (default: 'Info').
   * @param title The title of the toast (optional).
   * @param options Additional toast configuration options.
   * @returns The ActiveToast instance for further interaction.
   */
  info(
    message: string = "Info",
    title?: string,
    options?: Partial<IndividualConfig>
  ): ActiveToast<any> {
    return this.toastr.info(message, title, options);
  }

  /**
   * Shows a warning toast message.
   * @param message The message to display (default: 'Warn').
   * @param title The title of the toast (optional).
   * @param options Additional toast configuration options.
   * @returns The ActiveToast instance for further interaction.
   */
  warn(
    message: string = "Warn",
    title?: string,
    options?: Partial<IndividualConfig>
  ): ActiveToast<any> {
    return this.toastr.warning(message, title, options);
  }
}